import "./Footer.css";
import { useTranslation } from "../i18n";


function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footerWrapper">
        <p className="footer-copy">
          <span className="footer-brand-line">
            <span>© 2021-2025</span>
            <a className="link theqahub-font" href="/" translate="no">{"</"}TheQAHub{">"}</a>
          </span>
          <span className="footer-author" translate="no">BY DIEGO SANCHEZ MARTIN</span>
          <span className="footer-rights">{t("footer.rights")}</span>
          <a className="link footer-privacy" href="/privacy-policy">{t("footer.privacy")}</a>
        </p>
      </div>  
    </footer>
  );
}

export default Footer;
